import L from 'leaflet'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'
import type { Layer, Marker } from 'leaflet'
class OverLayers {
  map: MyMap
  options = {
    shape: 'Polygon', //指定绘制类型
    templineStyle: {
      color: 'red',
      dashArray: [5, 5],
    },
    hintlineStyle: {
      color: 'red',
      dashArray: [5, 5],
    },
    markerStyle: {
      //mark 样式
      draggable: true,
    },
    pathOptions: {
      //line,pology 有效
      dash: true,
      dashArray: [5, 5],
    },
    draggable: true,
    snappable: false,
  }

  // 长方形正方形
  Rectange = {
    options: {
      shape: 'Rectangle', //指定绘制类型
      templineStyle: {
        color: 'red',
        dashArray: [5, 5],
        weight: 1,
      },
      hintlineStyle: {
        color: 'red',
        dashArray: [5, 5],
        weight: 1,
      },
      pathOptions: {
        color: 'rgba(255,0,0)',
        fillColor: 'rgba(255,0,0)',
        fillOpacity: 0.2,
        dashArray: [5, 5],
        weight: 1,
      },
    },
  }
  // 多边形
  Polygon = {
    options: {
      shape: 'Polygon', //指定绘制类型
      templineStyle: {
        color: 'red',
        dashArray: [5, 5],
        weight: 1,
      },
      hintlineStyle: {
        color: 'red',
        dashArray: [5, 5],
        weight: 1,
      },
      pathOptions: {
        color: 'rgba(255,0,0)',
        fillColor: 'rgba(255,0,0)',
        fillOpacity: 0.2,
        dashArray: [5, 5],
        weight: 1,
      },
    },
  }
  Circle = {
    options: {
      shape: 'Circle', //指定绘制类型
      //实线
      templineStyle: {
        color: 'red',
        dashArray: [5, 5],
        weight: 1,
      },
      //虚线
      hintlineStyle: {
        color: 'red',
        dashArray: [5, 5],
        weight: 1,
      },
      //绘制完成后
      pathOptions: {
        color: 'red',
        fillColor: 'red',
        fillOpacity: 0.2,
        dashArray: [5, 5],
        weight: 1,
      },
      radius: 0,
    },
  }
  Sector = {
    options: {
      // 中心点坐标
      radius: 60, // 半径，单位米
      startAngle: -45, // 起始角度，以度为单位，从北方开始逆时针计算
      stopAngle: 45, // 结束角度
      fillColor: '#ff7800', // 填充颜色
      fillOpacity: 0.5, // 填充透明度
      stroke: true,
      color: '#000', // 边缘颜色
      dashArray: [],
      weight: 3,
      opacity: 1,
      clickable: true,
      draggable: false, // 是否可拖动，默认为false
      keyboard: true,
      zIndexOffset: 1000,
    },
  }

  FreeDraw = {
    options: {
      shape: 'FreeDraw', //指定绘制类型
      templineStyle: {
        color: 'red',
        dashArray: [5, 5],
        weight: 1,
      },
      hintlineStyle: {
        color: 'red',
        dashArray: [5, 5],
        weight: 1,
      },
      pathOptions: {
        color: 'rgba(255,0,0)',
        fillColor: 'rgba(255,0,0)',
        fillOpacity: 0.2,
        dashArray: [5, 5],
        weight: 1,
      },
    },
  }
  //是否回调经纬度坐标窗口
  callbackWin = 1
  temp_areaID = 'Temp_elane_area_001'
  //绘制实例存储
  _drawInstance: any = null
  //绘制数据绘制层
  layerHash = {}
  //绘制绘制层名称描述
  layerHashName: Record<string, any> = {}

  _zoomend = false
  _tempAreaArray: any[] = []
  hashData = []
  drawMarker: Record<string, Marker> = {}
  constructor(map: MyMap, options?: any) {
    this.map = map
    if (options) {
      this.options = options
    }
    this.init()
  }
  init() {
    // this.list();
    this.onLayerChange()
    this.polyNameChange()
    //tips:此处事件可能对后续其他绘制有影响（Aalon）
    //多边形绘制完成触发事件
    this.map.on('pm:create', (eg) => {
      if (eg.shape != 'Marker') {
        const ly = eg.layer as any

        ly && (this._drawInstance = ly)

        this._showInputArea()

        ly && (this.layerHash[this.temp_areaID] = ly)
        //开启编辑
        ly && this.map.Draw.edit(ly)

        //此处绘制样式调整因源码不支持扩展 eg:L.circle(t, { radius: n }).addTo(this._map)
        //强制处理 aalon
        if (eg.shape == 'Circle') {
          ly &&
            ly.setStyle(
              Object.assign(
                { color: 'red', weight: 1 },
                {
                  color: 'red',
                  fillColor: 'red',
                  fillOpacity: 0.2,
                  dashArray: [5, 5],
                  weight: 1,
                }
              )
            )
        }

        this._layerChange()
        //调整地图显示层级
        this.map &&
          this.map.shipsService &&
          this.map.shipsService.setZIndex(300)
      }
    })
    //绘制事件
    this.map.on('pm:drawstart', (eg) => {
      const layer = eg.workingLayer
      //only for polines&&polgons
      layer.on('pm:vertexadded', () => {
        this._showInputArea()
      })
    })
    // $('body').append("<span id='messureLength' style='display:none;'></sapn>")
  }

  //与录入框交互
  _showInputArea() {
    const layer = this.getLayer()
    if (layer) {
      const latlngs = layer.getLatLngs ? layer.getLatLngs() : layer.getLatLng()
      console.log(latlngs, '录入文本框内容')
    }
    // var e = this
    // var type = $('.area_way .on').attr('data-type')
    // type && $('#shape_point').length && e[type].inputArea('shape_point')
    //自定义锚地提醒的圈 alpha 20210329
    //if ($("#" + layer.getlayerid('_shipWarnShow')).css('display')!="none") {
    //    e['Circle'].inputArea('distance');
    //}
  }

  _layerChange() {
    if (this._drawInstance) {
      //拖动事件
      this._drawInstance.on('pm:drag', () => {
        this.callbackWin = 1
        this._showInputArea()
      })
      //拖动添加点
      this._drawInstance.on('pm:vertexadded', () => {
        this.callbackWin = 1
        this._showInputArea()
      })
      //拖动移除点
      this._drawInstance.on('pm:vertexremoved', () => {
        this.callbackWin = 1
        this._showInputArea()
      })
      //marker 拖动
      this._drawInstance.on('pm:markerdragend', () => {
        this.callbackWin = 1
        this._showInputArea()
      })
      // //ciccle _outerMarker move ：Aalon【2020-01-16 10:44】
      this._drawInstance.pm._outerMarker &&
        this._drawInstance.pm._outerMarker.on('move', () => {
          this.callbackWin = 1
          this._showInputArea()
          //离锚圈
          // elane.AlphaCIrcle._showInputArea()
        })
      this._drawInstance.on('pm:markerdragstart', () => {
        this.callbackWin = 1
        this._showInputArea()
        //离锚圈
        // elane.AlphaCIrcle._showInputArea()
      })
    }
  }

  //监听layer变动事件事件:[]
  onLayerChange() {
    //e.lyinterval && clearInterval(e.lyinterval)
    //e.lyinterval = setInterval(()=> {
    //    var type = $(".area_way .on").attr("data-type")
    //    if (elane.overLayers._drawInstance
    //    && type
    //    && $('#shape_point').length) {
    //        var ly = elane.overLayers.getLayer();
    //        //数据有效 且区域不等执行 保存
    //        try {
    //            if (elane.overLayers.historyLy) {
    //                if (ly.getBounds
    //                && elane.overLayers.historyLy.getBounds
    //                && (!(ly.getBounds().equals(elane.overLayers.historyLy.getBounds())))) {
    //                    elane.overLayers.historyLy = L.extend({}, ly);
    //                    elane.overLayers[type].inputArea('shape_point')
    //                }
    //            } else {
    //                elane.overLayers.historyLy = L.polygon([[90, -180], [90, 180], [-90, -180], [-90, 180]]);
    //                elane.overLayers[type].inputArea('shape_point');
    //            }
    //        } catch (e) {
    //        }
    //    }
    //}, 500);
  }

  //  区域名称绘制逻辑
  //  1:当前可视范围内区域名称重绘
  //  2:处于编辑的区域屏蔽展示
  //  3:事件调整 缩放执行延迟添加
  ///
  polyNameChange() {
    this.map.on('zoomend', () => {
      this._zoomend = !0
    })
    this.map.on('moveend', () => {
      const id = CommUtils.getUuid(12) //$('#_addAreaBox').attr('data-areaid')
      this._tempAreaArray = []
      for (const item in this.layerHashName) {
        const ly = this.layerHashName[item]
        ly && this.map.removeLayer(ly)
        const d = this.hashData[item]
        if (this.layerHash[item]) {
          this.layerHash[item] && this.layerHash[item].redraw()
          const lbounds = this.layerHash[item].getBounds()
          if (lbounds.isValid()) {
            if (this.map.getBounds().intersects(lbounds)) {
              this.layerHashName[item] = this.showName(
                this.layerHash[item],
                d ? d.AreaName : ''
              )
              //编辑区域时临时移除区域名称显示
              if (!(window['addArea'] && id == item))
                if (!this._zoomend)
                  //缩放延迟执行添加
                  this.layerHashName[item] &&
                    this.map.addLayer(this.layerHashName[item])
                else {
                  this._tempAreaArray.push(this.layerHashName[item])
                }
            }
          }
        }
      }
      //延迟绘制
      setTimeout(() => {
        //e.layerHashName[item] && this.map.addLayer(e.layerHashName[item])
        this._tempAreaArray.forEach((item) => {
          item && this.map.addLayer(item)
        })
      }, 0)
      this._zoomend = !1

      // 将船层置,如果没有测试轨迹打开着，这里将船置顶
      // if (!$('#Math').hasClass('math_on')) {
      this.map && this.map.shipsService && this.map.shipsService.restoreZIndex()
      // }
    })
  }

  showName(p: Layer, name = '') {
    const color = this.map.mapType != 'MT_SATELLITE' ? '#333' : '#fff'
    return CommUtils.getFeatureLabel(p, name, {
      attributes: {
        fill: color,
        xShift: 0,
        offset: 0,
      },
    } as any)
  }

  initDraw(type: string) {
    //开始绘制
    this.options.shape = type
    this.start(this[type] ? this[type].options : this.options)
  }
  //移除绘制层
  remove(id: string) {
    const ly = this.layerHash[id],
      lyName = this.layerHashName[id]
    if (ly) {
      try {
        lyName && this.map.removeLayer(lyName)
        this.map && this.map.Draw && this.map.Draw.remove(ly)
      } catch {}
      delete this.layerHash[id]
    }
  }

  //移除所有层
  clear() {
    const layers = this.layerHash
    if (layers) {
      for (const i in layers) {
        //临时绘制不清空
        !i.includes('Temp_elane') && this.remove(i)
      }
    }
  }

  //统一绘制开始
  start(opts: any) {
    //移除标注
    // elane.mark.markRemove();

    //获取绘制属性
    this.setOpts(opts)
    //清除绘制对象实例
    this.end()
    //开始绘制
    this._drawInstance =
      this.map && this.map.Draw && this.map.Draw.begin(this.options)
  }
  //结束绘制
  end(areaid?: undefined) {
    //如果存在先结束绘制
    if (this._drawInstance && !areaid) {
      try {
        this.map.Draw.end(this._drawInstance)
        //移除
        this.removeInstanceLayer()
      } catch (ex) {
        console.log(`The Draw Instache end Error:${ex}`)
        //移除
        this.removeInstanceLayer()
        return
      }
    }
  }
  //结束编辑
  endEdit(id: string) {
    //如果编辑则取消当前编辑
    id && this.layerHash[id] && this.map.Draw.cancelEdit(this.layerHash[id])
    id && this.hashData[id] && !this.hashData[id].IsShow && this.remove(id)
  }

  //清除绘制层
  removeInstanceLayer() {
    let l
    if (this._drawInstance) {
      try {
        //获取清除并层
        l = this.map.Draw.getLayer(this._drawInstance)
        l && this.map.Draw.remove(l)
        this._drawInstance = null
      } catch (e) {
        console.log(`The Draw Instache remove Error:${e}`)
      }
    }
  }
  //设置绘制属性
  setOpts(ops: any) {
    L.extend(this.options, ops)
  }
  //获取绘制层
  getLayer() {
    let l
    if (this._drawInstance) {
      try {
        //获取清除并层
        l = this.map.Draw.getLayer(this._drawInstance)
      } catch {}
    }
    return l
  }

  //显示多边形
  showArea(
    d: {
      Points: any
      AreaID: string
      AreaStyle: string
      AreaShape: number
      Radius: number
      AreaName: string | undefined
    },
    locate: boolean
  ) {
    //展示已绘制对象
    let latLngs = []
    const _lats = d.Points.split(',')
    for (let k = 0; k < _lats.length - 1; k = k + 2) {
      try {
        const p = CanvasShipUtils.GPSEncryptByMapToLatLng(
          L.latLng(
            Number.parseFloat(_lats[k + 1]),
            Number.parseFloat(_lats[k])
          ),
          this.map
        )
        latLngs.push(p.wrap())
      } catch (e) {
        console.log(`data is not available:${e}`)
      }
    }
    latLngs = CanvasShipUtils.latlngsFrom180(latLngs)
    this.layerHash[d.AreaID] && this.remove(d.AreaID)
    //测试去掉
    ///（0-矩形，1-不规则，2-圆）
    let pathOptions = (d.AreaStyle && JSON.parse(d.AreaStyle)) || {}
    pathOptions['dashArray'] = [5, 5] //强制把实实线改为虚线（纠正历史数据）
    if (d.AreaShape == 0 || d.AreaShape == 1) {
      pathOptions = Object.assign(
        {
          color: '#e41120',
          weight: 1,
          fillColor: 'none',
          fillOpacity: 0,
        },
        pathOptions
      )
      this.layerHash[d.AreaID] = this.map.Draw.show(latLngs, {
        shape: 'Polygon',
        locate,
        pathOptions,
      })
    } else if (d.AreaShape == 2) {
      pathOptions = Object.assign(
        {
          color: '#e41120',
          weight: 1,
          fillColor: 'none',
          fillOpacity: 0,
          radius: d.Radius * 1852,
        },
        pathOptions
      )
      this.layerHash[d.AreaID] = this.map.Draw.show(latLngs, {
        shape: 'Circle',
        locate,
        pathOptions,
      })
    }
    //绑定区域名称
    if (d.AreaName) {
      this.layerHashName[d.AreaID] = this.showName(
        this.layerHash[d.AreaID],
        d.AreaName
      )
      this.layerHashName[d.AreaID] &&
        this.map.addLayer(this.layerHashName[d.AreaID])
    }
  }

  /**
   * 清除绘制的marker
   */
  drawMarkClear() {
    const objIDS = Object.keys(this.drawMarker)
    for (const objID of objIDS) {
      const _layer = this.drawMarker[objID]
      if (_layer) {
        this.map.removeLayer(_layer)
      }
    }
  }

  /**
   * 显示marker
   * @param item
   * @param locate 是否定位
   */
  showMarker(
    item: {
      MarkerType: string
      Lat: number
      Lon: number
      MarkerName: string
      MarkerID: string | number
      IsShow: number
    },
    locate = true
  ) {
    const sig = L.icon({
      iconUrl: `https://cdn.xplusship.com/img/images/flag/flag${item.MarkerType}.png`,
      iconSize: [16, 16], // size of the icon
      shadowSize: [0, 0], // size of the shadow
      iconAnchor: [8, 16], // point of the icon which will correspond to marker's location
      shadowAnchor: [0, 0], // the same for the shadow
      popupAnchor: [0, 0],
    })
    const newP = CanvasShipUtils.GPSEncryptByMapToLatLng(
      L.latLng(item.Lat, item.Lon),
      this.map
    )
    const latLng: L.LatLngExpression = [newP.lat, newP.lng]
    const matker = L.marker(latLng, {
      icon: sig,
    }).bindTooltip(`<em></em>${item.MarkerName}`, {
      direction: 'right',
      permanent: true,
      className: 'my_css_class',
    })

    this.drawMarker[item.MarkerID] = matker

    if (item.IsShow == 1) {
      matker.addTo(this.map)
    }
    if (locate) {
      this.map.fitBounds([latLng] as any)
    }
  }

  //调整区域名称偏移
  getDescriptOffset() {
    const offset = {
      X: 10,
      Y: 0,
    }
    return offset
  }

  //页面统一显示GPS
  _showLatLntToGPS(latLng: any) {
    const ll = L.extend({}, latLng)
    return CanvasShipUtils.getGPSLatLngByMap(ll, this.map)
  }
}

export { OverLayers }
